<div class="applications">
    <div class="applications__list">
        @for (application of cvBoxApplications$ | async; track $index) {
            <div class="application">
                <div class="application__main">
                    @if (application.customerStatusId == customerStatus.Active) {
                        <a class="application__title application__title--link"
                           [routerLink]="['/customer', application.customerId]">{{ application.customerName }}</a>
                    } @else {
                        <span class="application__title">{{ application.customerName }}</span>
                    }
                </div>

                <div class="application__dates">
                    <span class="application__period">
                        {{ 'label.ApplicationDate' | translate }}: {{ $any(application).date | date:'M/d/yy' }}
                    </span>
                </div>

                <div class="application__status">
                    <span class="status"
                          [class.status--approved]="application.statusId == cvBoxApplicationStatus.Approved"
                          [class.status--rejected]="application.statusId == cvBoxApplicationStatus.Rejected">
                        {{ applicationStatusNameMap[application.statusId] | translate }}
                    </span>
                </div>
            </div>
        }
    </div>

    @if ((cvBoxApplications$ | async)?.length > 0) {
        @if ({ pageCount: pageCount$ | async, navItems: navItems$ | async, currentPage: currentPage$ | async }; as data) {
            <div class="applications__paging">
                <app-paging [currentPage]="data.currentPage"
                            [pageCount]="data.pageCount"
                            [pagingNavItems]="data.navItems"
                            (onPageNav)="onPagignNavigation($event)"></app-paging>
            </div>
        }
    }
</div>
